import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class PeculioService extends BaseService {
  editDependentesPeculio() {
    const url = `${environment.portalApi}/Peculio/EditDependentsPeculio`;
    return this.http.post(url, { headers: this.createHeader() });
  }
  getDependentesPeculio() {
    const url = `${environment.portalApi}/Peculio/GetDependentsPeculio`;
    return this.http.get(url, { headers: this.createHeader() });
  }
  getValuesPeculio() {
    const url = `${environment.portalApi}/Peculio/GetValuesOptions`;
    return this.http.get(url, { headers: this.createHeader() });
  }
  getPeculio() {
    const url = `${environment.portalApi}/Peculio/GetPlanDetails`;
    return this.http.get(url, { headers: this.createHeader() });
  }
  postSavePeculio(model: any) {
    let url = environment.portalApi + '/Peculio/SaveOptionPeculio';
    return this.http.post(url, model, { headers: this.createHeader() });
  }
  getPeculioSolicitation() {
    const url = `${environment.portalApi}/Peculio/GetPeculioSolicitations`;
    return this.http.get(url, { headers: this.createHeader() });
  }
}